<template>
  <BlBackdrop
    title="Edit personal information"
    label="Update"
    :disabled="isDisabledSubmit"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onSave"
  >
    <div
      class="grid items-center grid-cols-6 gap-4 px-8 overflow-y-auto"
      :style="{ width: '48rem', maxHeight: 'calc(100vh - 14rem)' }"
    >
      <BlInputText
        class="col-span-6"
        :input="nameInput"
        @changed="inputHandler"
      />
      <!--  -->
      <BlInputDate
        class="col-span-3"
        :input="dateOfBirthInput"
        @changed="inputHandler"
      />
      <BlSelectBox
        class="col-span-3"
        label="Status"
        asterisk
        v-model="statusInput"
        placeholder="Select status"
        :options="statusOptions"
        @change="statusInput = $event"
      />
      <!--  -->
      <BlInputDate
        class="col-span-3"
        :input="dateAdmittedInput"
        @changed="inputHandler"
      />
      <BlInputDate
        class="flex-grow col-span-3"
        :input="dateOfDischargeInput"
        @changed="inputHandler"
      />
      <!--  -->
      <div v-if="enableSalesPipeline" class="flex flex-col col-span-6 gap-1">
        <BlSelectBox
          label="Discharge reason"
          :asterisk="dischargeReasonInput.asterisk"
          v-model="dischargeReasonInput.model"
          :disabled="dischargeReasonInput.disabled"
          placeholder="Select discharge reason"
          :options="dischargeReasonOptions"
          @change="dischargeReasonInput.model = $event"
        />
        <BlInputText
          v-if="dischargeReasonInput.model === 'other'"
          :input="otherDischargeReasonInput"
          @changed="inputHandler"
        />
      </div>
      <!--  -->
      <BlSelectBox
        class="col-span-3"
        label="Gender"
        v-model="genderInput"
        placeholder="Select gender"
        :options="genderOptions"
        @change="genderInput = $event"
      />
      <BlInputText
        class="col-span-3"
        :input="emailInput"
        @changed="inputHandler"
      />
      <!--  -->
      <BlInputText
        class="col-span-6"
        :input="noteInput"
        @changed="inputHandler"
      />
      <!--  -->
      <BlSearchBox
        v-if="enableBranch"
        class="col-span-6"
        type="branch"
        label="Branch Tags"
        drop="up"
        placeholder="Type tag"
        v-model="branchesInput"
        :options="branchOptions"
        @change="branchesInput = $event"
      />
      <BlSearchBox
        class="col-span-6"
        label="Client tags"
        drop="up"
        placeholder="Type tag"
        v-model="tagsInput"
        :options="labels.map(i => ({ value: i.id, label: i.name }))"
        @change="tagsInput = $event"
      />
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

import BlBackdrop from "../../BlBackdrop.vue";
import BlInputText from "../../BlInputText.vue";
import BlInputDate from "../../BlInputDate.vue";
import BlSelectBox from "../../BlSelectBox.vue";
import BlSearchBox from "../../BlSearchBox.vue";

export default {
  name: "EditClientAboutModal",
  components: {
    BlBackdrop,
    BlInputText,
    BlInputDate,
    BlSelectBox,
    BlSearchBox
  },
  data() {
    return {
      submitLoading: false,
      nameInput: {
        label: "Child's full name",
        placeholder: "Type name",
        asterisk: true,
        model: ""
      },
      dateOfBirthInput: {
        label: "Date of birth",
        asterisk: true,
        model: ""
      },
      statusInput: "",
      statusOptions: [
        { value: "active", label: "Active" },
        { value: "archived", label: "Discharged" },
        { value: "at_risk_of_discharge", label: "At risk of discharge" }
      ],
      dateAdmittedInput: {
        label: "Date admitted",
        asterisk: true,
        disabled: false,
        model: ""
      },
      dateOfDischargeInput: {
        label: "Date of discharge",
        asterisk: true,
        disabled: true,
        model: ""
      },
      dischargeReasonInput: {
        label: "Date of discharge",
        asterisk: false,
        disabled: true,
        model: ""
      },
      dischargeReasonOptions: [
        { value: "graduated", label: "Graduated" },
        { value: "family_or_personal_issues", label: "Family/personal issue" },
        {
          value: "expectations_did_not_match",
          label: "Expectations didn't meet"
        },
        { value: "schedule_conflict", label: "Schedule conflict" },
        { value: "moving", label: "Moving" },
        { value: "too_expensive", label: "Too expensive" },
        { value: "other", label: "Others" }
      ],
      otherDischargeReasonInput: {
        textarea: true,
        placeholder: "Provide a reason for the discharge client (required)",
        model: ""
      },
      genderInput: "",
      genderOptions: [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" }
      ],
      emailInput: {
        label: "Email",
        placeholder: "Type email",
        model: ""
      },
      noteInput: {
        label: "Note",
        placeholder: "Type note",
        textarea: true,
        model: ""
      },
      tagsInput: [],
      branchesInput: []
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentCenter",
      "branches",
      "labels",
      "client"
    ]),
    enableSalesPipeline() {
      return this.currentCenter.enable_sales_pipeline;
    },
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    branchOptions() {
      return this.branches.map(i => ({
        value: i.id,
        label: i.name,
        color: i.color,
        backgroundColor: i.background_color
      }));
    },
    isDisabledSubmit() {
      if (this.submitLoading) return true;
      // Basic checks
      if (!this.nameInput.model) return true;
      if (!this.dateOfBirthInput.model) return true;
      if (!this.statusInput) return true;

      // Type-specific checks
      if (this.enableSalesPipeline) {
        if (this.statusInput === "archived") {
          if (!this.dischargeReasonInput.model) return true;
          if (this.dischargeReasonInput.model === "other") {
            if (!this.otherDischargeReasonInput.model) return true;
          }
        }
      }
      return false;
    }
  },
  watch: {
    statusInput(val) {
      if (val === "archived") {
        this.dateOfDischargeInput.disabled = false;
        this.dischargeReasonInput.asterisk = true;
        this.dischargeReasonInput.disabled = false;
      } else {
        this.dateOfDischargeInput.disabled = true;
        this.dischargeReasonInput.model = null;
        this.dischargeReasonInput.asterisk = false;
        this.dischargeReasonInput.disabled = true;
        this.otherDischargeReasonInput.model = null;
      }
    },
    dischargeReasonInput(val) {
      if (val.model !== "other") {
        this.otherCancellationReasonInput.model = "";
      }
    }
  },
  mounted() {
    this.generateData(this.client);
  },
  methods: {
    ...mapActions(["updateClient"]),
    generateData(val) {
      if (val) {
        const admittedAt = val.admitted_at
          ? moment(val.admitted_at).format("YYYY-MM-DD")
          : "";
        const archivedAt = val.archived_at
          ? moment(val.archived_at).format("YYYY-MM-DD")
          : "";

        this.nameInput.model = val.name;
        this.dateOfBirthInput.model = val.birthday;
        this.statusInput = val.status;
        this.dateAdmittedInput.model = admittedAt;
        this.dateOfDischargeInput.model = archivedAt;
        this.dischargeReasonInput.model = val.discharge_reason
          ? val.discharge_reason
          : null;
        this.otherDischargeReasonInput.model = val.other_discharge_reason
          ? val.other_discharge_reason
          : null;
        this.genderInput = val.gender;
        this.emailInput.model = val.email;
        this.noteInput.model = val.note;
        this.tagsInput = val.tags.map(i => i.label_id);
        this.branchesInput = val.branches.map(i => i.id);
      }
    },
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    onSave() {
      const data = {
        id: this.client.id,
        name: this.nameInput.model,
        birthday: this.dateOfBirthInput.model,
        status: this.statusInput,
        archived_at: this.dateOfDischargeInput.model,
        discharge_reason: this.dischargeReasonInput.model,
        other_discharge_reason: this.otherDischargeReasonInput.model,
        gender: this.genderInput,
        email: this.emailInput.model,
        note: this.noteInput.model,
        label_ids: this.tagsInput,
        branch_ids: this.branchesInput
      };
      if (!this.client.prospect_id) {
        data["admitted_at"] = this.dateAdmittedInput.model;
      }

      this.submitLoading = true;
      this.updateClient(data).then(({ success }) => {
        this.submitLoading = false;
        if (!success) return;
        this.$emit("close-modal");
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/about/EditClientAboutModal.vue